<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="700px"
    center
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="平台名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入平台名称" maxlength="50" readonly />
      </el-form-item>
      
      <el-form-item label="系统类型" prop="os_type">
        <el-radio-group v-model="form.os_type">
          <el-radio :label="1">Android</el-radio>
          <el-radio :label="2">iOS</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="升级版本" prop="upgrade_version_id">
        <el-select v-model="form.upgrade_version_id" placeholder="请选择升级版本" style="width: 100%" @change="getTargetVersion">
          <el-option 
            v-for="item in upgradeVersionList" 
            :key="item.id" 
            :label="item.version" 
            :value="item.id" 
          />
        </el-select>
        <span style="color: #999; font-size: 12px; margin-left: 10px;">( 此版本及以下版本升级 )</span>
      </el-form-item>
      
      <el-form-item label="目标版本" prop="target_version_id">
        <el-select v-model="form.target_version_id" placeholder="请选择目标版本" style="width: 100%">
          <el-option 
            v-for="item in targetVersionList" 
            :key="item.id" 
            :label="item.version" 
            :value="item.id" 
          />
        </el-select>
      </el-form-item>
      
      <el-form-item label="更新方式" prop="upgradeType">
        <el-radio-group v-model="form.upgradeType">
          <el-radio label="show_upgrade">提示更新</el-radio>
          <el-radio label="force_upgrade">强制更新</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="更新提示" prop="upgrade_tip">
        <el-input
          v-model="form.upgrade_tip"
          type="textarea"
          :rows="6"
          placeholder="请输入更新提示"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>
      

      
      <el-form-item label="状态" prop="enable">
        <el-radio-group v-model="form.enable">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAppUpgrade, getAppVersionList } from '@/api/custom-frontend'

export default {
  name: 'UpgradeEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    appInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: null,
        app_id: '',
        title: '物流保险师',
        os_type: 1,
        upgrade_version_id: 0,
        target_version_id: 0,
        upgradeType: 'show_upgrade',
        show_upgrade: true,
        force_upgrade: false,
        upgrade_tip: '',
        enable: true
      },
      upgradeVersionList: [],
      targetVersionList: [],
      rules: {
        title: [
          { required: true, message: '请输入平台名称', trigger: 'blur' },
          { max: 50, message: '平台名称不能超过50个字符', trigger: 'blur' }
        ],
        os_type: [
          { required: true, message: '请选择系统类型', trigger: 'change' }
        ],
        upgrade_version_id: [
          { required: true, message: '请选择升级版本', trigger: 'change' }
        ],
        target_version_id: [
          { required: true, message: '请选择目标版本', trigger: 'change' }
        ],
        upgradeType: [
          { required: true, message: '请选择更新方式', trigger: 'change' }
        ],
        upgrade_tip: [
          { required: true, message: '请输入更新提示', trigger: 'blur' },
          { max: 1000, message: '更新提示不能超过1000个字符', trigger: 'blur' }
        ],

      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.getUpgradeVersionList()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { 
            ...val,
            title: val.app_name || '物流保险师',
            upgradeType: val.show_upgrade ? 'show_upgrade' : 'force_upgrade'
          }
          if (val.id) {
            // 先获取升级版本列表，然后获取目标版本列表
            this.getUpgradeVersionList().then(() => {
              this.getTargetVersionList()
            })
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    },
    appInfo: {
      handler(val) {
        if (val && val.id) {
          this.form.app_id = val.id
        }
      },
      immediate: true
    },
    'form.upgradeType'(val) {
      if (val === 'show_upgrade') {
        this.form.show_upgrade = true
        this.form.force_upgrade = false
      } else {
        this.form.show_upgrade = false
        this.form.force_upgrade = true
      }
    },
    'form.os_type'() {
      // 系统类型变化时重新获取版本列表
      this.form.upgrade_version_id = 0
      this.form.target_version_id = 0
      this.getUpgradeVersionList()
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        app_id: this.appInfo.id || '',
        title: '物流保险师',
        os_type: 1,
        upgrade_version_id: 0,
        target_version_id: 0,
        upgradeType: 'show_upgrade',
        show_upgrade: true,
        force_upgrade: false,
        upgrade_tip: '',
        enable: true
      }
      this.upgradeVersionList = []
      this.targetVersionList = []
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    
    async getUpgradeVersionList() {
      try {
        const params = {
          name: this.form.title,
          os_type: this.form.os_type,
          without_latest_version: true
        }
        
        const res = await getAppVersionList(params)
        if (res && res.err_code === 0) {
          this.upgradeVersionList = [{ id: 0, version: '请选择' }, ...res.rows]
        }
        return res
      } catch (error) {
        console.error('获取升级版本列表失败:', error)
        return null
      }
    },
    
    async getTargetVersionList() {
      if (this.form.upgrade_version_id === 0 || this.upgradeVersionList.length <= 1) {
        this.targetVersionList = []
        return
      }
      
      try {
        const upgradeVersion = this.upgradeVersionList.find(item => item.id === this.form.upgrade_version_id)
        if (!upgradeVersion) return
        
        const params = {
          name: this.form.title,
          os_type: this.form.os_type,
          upgrade_version: upgradeVersion.version
        }
        
        const res = await getAppVersionList(params)
        if (res && res.err_code === 0) {
          this.targetVersionList = [{ id: 0, version: '请选择' }, ...res.rows]
        }
      } catch (error) {
        console.error('获取目标版本列表失败:', error)
      }
    },
    
    getTargetVersion() {
      // 升级版本变化时重置目标版本
      this.form.target_version_id = 0
      this.getTargetVersionList()
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    async handleSave() {
      try {
        await this.$refs.form.validate()
        
        // 验证必填字段
        if (this.form.upgrade_version_id === 0) {
          this.$message.error('请选择需要升级版本')
          return
        }
        if (this.form.target_version_id === 0) {
          this.$message.error('请选择升级目标版本')
          return
        }
        
        const data = { ...this.form }
        data.app_id = 1 // 固定为1，与老项目保持一致
        
        // 清除不需要的字段
        delete data.upgradeType
        delete data.title
        
        if (!data.id) {
          delete data.id
        }
        
        const res = await saveAppUpgrade(data)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}
</style>